import { useT } from "@/lib/i18n";

export type CaseMention = { outlet: string; url: string };
export type FamousCase = {
  slug: string;
  year: string;
  area: string;
  role: string;
  headline: string;
  summary: string;
  mentions: CaseMention[];
};

/**
 * PULSO33 customer case studies — generic descriptions, no client identifying
 * data. Headlines / summaries flow through tk() for backoffice editing.
 */
export function useCases(): FamousCase[] {
  const { tk } = useT();
  return [
    {
      slug: "ai-agent-support",
      year: "2025",
      area: tk("cases.agent.area", "AI Agents · Customer Support"),
      role: tk("cases.agent.role", "Architecture, build and ongoing operation"),
      headline: tk(
        "cases.agent.headline",
        "From 0 to a multilingual AI agent answering 80% of inbound requests"
      ),
      summary: tk(
        "cases.agent.summary",
        "We designed and deployed a production AI agent connected to the client's CRM, knowledge base and ticketing system. The agent resolves 80% of inbound requests autonomously, escalates the rest with full context and learns from every interaction."
      ),
      mentions: [
        { outlet: "Case study", url: "https://pulso33.com" },
      ],
    },
    {
      slug: "cloud-migration",
      year: "2024",
      area: tk("cases.cloud.area", "Cloud & DevOps · Migration"),
      role: tk("cases.cloud.role", "End-to-end migration and SRE"),
      headline: tk(
        "cases.cloud.headline",
        "Zero-downtime migration to a modern edge platform"
      ),
      summary: tk(
        "cases.cloud.summary",
        "We replatformed a legacy stack onto a modern serverless edge architecture with Terraform-driven infrastructure, CI/CD pipelines and full observability — improving p95 latency by 4× and cutting hosting cost by 60%."
      ),
      mentions: [
        { outlet: "Case study", url: "https://pulso33.com" },
      ],
    },
  ];
}
